module.exports = __webpack_public_path__ + "img/DraftsOutlined.c8fff859.svg";